import Vue from "vue";
import vuetify from "./vuetify";
import App from "./App.vue";
import exporter from "./features/schemas/services/exporter";
import router from "./routes";
import setupInterceptor from './services/interceptor'
import store from "./store/store";
import { handleError } from "./services/errorUtility";
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

import "./components";
import "./features/schemas/formFields"
import "./features/schemas/tableCells"
import "./mixins/mixins";
import "./features/schemas/components";
import "@mdi/font/css/materialdesignicons.css";

Vue.config.productionTip = false;
Vue.config.errorHandler = handleError;

Vue.use(TiptapVuetifyPlugin, {
    // the next line is important! You need to provide the Vuetify Object to this place.
    vuetify, // same as "vuetify: vuetify"
    // optional, default to 'md' (default vuetify icons before v2.0.0)
    iconsGroup: 'mdi'
})

setupInterceptor();

new Vue({
    vuetify,
    router,
    store,
    exporter,
    render: h => h(App),
}).$mount("#app");
